import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { selectedAccommodationId } from '@/layouts/queries'

export function useRCVoucher() {
  const route = useRoute()

  const queryCode = (route.query?.['voucherCode'] as string) ?? ''
  const pendingCode = window.sessionStorage.getItem('rc_voucher_pending_code') ?? ''
  const pendingItemId = window.sessionStorage.getItem('rc_voucher_pending_item_id') ?? ''
  const pendingMatchesCurrentAccommodation =
    !!pendingItemId && pendingItemId === String(selectedAccommodationId.value)

  const initialCode = queryCode || (pendingMatchesCurrentAccommodation ? pendingCode : '')

  const appliedCode = ref(initialCode)
  const isFromMarketingLink = ref(!!initialCode)

  const clearPendingVoucher = (): void => {
    window.sessionStorage.removeItem('rc_voucher_pending_code')
    window.sessionStorage.removeItem('rc_voucher_pending_item_id')
  }

  const removeVoucherCode = (): void => {
    appliedCode.value = ''
    isFromMarketingLink.value = false
    clearPendingVoucher()
  }

  return { appliedCode, isFromMarketingLink, removeVoucherCode, clearPendingVoucher }
}
